import React from 'react';
import styled from 'styled-components';
import ConsultingIcon from '../../icons/ConsultingIcon';
import CreateIcon from '../../icons/CreateIcon';
import CareIcon from '../../icons/CareIcon';
import MeatingIcon from '../../icons/MeatingIcon';
import PresentationIcon from '../../icons/PresentationIcon';
import SignIcon from '../../icons/SignIcon';
import BuildingIcon from '../../icons/BuildingIcon';
import PhoningIcon from '../../icons/PhoningIcon';
import ArrowDownIcon from '../../icons/ArrowDownIcon';

export default function MobilPlan() {
  return (
    <LineContainer>
      <Box>
        <IconBox>
          <PhoningIcon style={{ width: 50, height: 50 }} />
        </IconBox>
        <TextBox>
          <h4>Ověření a dohled</h4>
          <p>
            Ověření možností refinancování dle původních smluv
            a následný dohled nad včasnou přípravnou refinancování.
          </p>
        </TextBox>
      </Box>
      <ArrowDownIcon
        style={{
          width: 40,
          height: 40,
          margin: '0 auto',
          fill: 'rgba(255,0,0,.6',
          marginBottom: '24px',
        }}
      />
      <Box>
        <IconBox>
          <MeatingIcon style={{ width: 50, height: 50 }} />
        </IconBox>
        <TextBox>
          <h4>Schůzka</h4>
          <p>
            Vysvětlení principů spolupráce s JHavel Finance, vysvětlení průběhu financování.
          </p>
        </TextBox>
      </Box>
      <ArrowDownIcon
        style={{
          width: 40,
          height: 40,
          margin: '0 auto',
          fill: 'rgba(255,0,0,.6',
          marginBottom: '24px',
        }}
      />
      <Box>
        <IconBox>
          <ConsultingIcon style={{ width: 50, height: 50 }} />
        </IconBox>
        <TextBox>
          <h4>Projednání záměru</h4>
          <p>
            Projednání a následné stanovení základních parametrů, jako je výše úvěru, splatnost,
            délka fixace úrokové sazby.
          </p>
        </TextBox>
      </Box>
      <ArrowDownIcon
        style={{
          width: 40,
          height: 40,
          margin: '0 auto',
          fill: 'rgba(255,0,0,.6',
          marginBottom: '24px',
        }}
      />
      <Box>
        <IconBox>
          <SignIcon style={{ width: 50, height: 50 }} />
        </IconBox>
        <TextBox>
          <h4>Pověření zprostředkovatele</h4>
          <p>Pověření JHavel Finance k zajištění nabídek od jednotlivých institucí.</p>
        </TextBox>
      </Box>
      <ArrowDownIcon
        style={{
          width: 40,
          height: 40,
          margin: '0 auto',
          fill: 'rgba(255,0,0,.6',
          marginBottom: '24px',
        }}
      />
      <Box>
        <IconBox>
          <CreateIcon style={{ width: 50, height: 50 }} />
        </IconBox>
        <TextBox>
          <h4>Příprava nabídek</h4>
          <p>
            Příprava nabídek od všech institucí dle stanovených parametrů, úpraav dle
            požadavků klienta.
          </p>
        </TextBox>
      </Box>
      <ArrowDownIcon
        style={{
          width: 40,
          height: 40,
          margin: '0 auto',
          fill: 'rgba(255,0,0,.6',
          marginBottom: '24px',
        }}
      />
      <Box>
        <IconBox>
          <PresentationIcon style={{ width: 50, height: 50 }} />
        </IconBox>
        <TextBox>
          <h4>Vyhodnocení a doporučení nabídek</h4>
          <p>Předání všech finálních nabídek a doporučení ze strany JHavel Finance.</p>
        </TextBox>
      </Box>
      <ArrowDownIcon
        style={{
          width: 40,
          height: 40,
          margin: '0 auto',
          fill: 'rgba(255,0,0,.6',
          marginBottom: '24px',
        }}
      />
      <Box>
        <IconBox>
          <SignIcon style={{ width: 50, height: 50 }} />
        </IconBox>
        <TextBox>
          <h4>Podpis smluv</h4>
          <p>
            Zajištění podpisů smluv s financující institucí.
          </p>
        </TextBox>
      </Box>
      <ArrowDownIcon
        style={{
          width: 40,
          height: 40,
          margin: '0 auto',
          fill: 'rgba(255,0,0,.6',
          marginBottom: '24px',
        }}
      />
      <Box>
        <IconBox>
          <BuildingIcon style={{ width: 50, height: 50 }} />
        </IconBox>
        <TextBox>
          <h4>Spolupráce při refinancování</h4>
          <p>
            Spolupráce při samotném refinancování úvěru, komunikace s
            bankami a předání potřebných dokumnetů.
          </p>
        </TextBox>
      </Box>
      <ArrowDownIcon
        style={{
          width: 40,
          height: 40,
          margin: '0 auto',
          fill: 'rgba(255,0,0,.6',
          marginBottom: '24px',
        }}
      />
      <Box>
        <IconBox>
          <CareIcon style={{ width: 50, height: 50 }} />
        </IconBox>
        <TextBox>
          <h4>Péče v období splácení úvěru</h4>
          <p>
            Průběžná péče o klienta.
          </p>
        </TextBox>
      </Box>
    </LineContainer>
  );
}

const Box = styled.div`
  display: flex;
  align-items: center;
  margin: 0 auto 24px auto;
  width: 400px;

  @media(max-width: 450px) {
    width: 100%;
  }

  @media(max-width: 500px) {
    flex-direction: column;
    justify-content: flex-start;
  }
`;

const LineContainer = styled.div`
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  margin: 24px auto 0 auto;

  @media(min-width: 1280px) {
    display: none;
  }
`;

const IconBox = styled.div`
  border: 2px solid ${({ theme }) => theme.palette.black.light};
  border-radius: 100px;
  padding: 12px;
  margin-right: 36px;

  @media(max-width: 500px) {
    margin-right: 0;
    margin-bottom: 24px;
  }
`;

const TextBox = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;

  h4 {
    margin: 0;
    padding-bottom: 6px;
  }

  p {
    margin: 0;
  }

  @media(max-width: 500px) {
    width: 100%;
    text-align: center;

    h4{
      margin: 0 auto;
    }
  }

`;
